import React, { useState, useRef, useCallback } from 'react';

const Dropzone = ({ onFileSelect }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null); // ← Nuevo estado
  const fileInputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      setSelectedFile(file);
      if (onFileSelect) onFileSelect(file);
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileInputChange = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      const file = files[0];
      setSelectedFile(file);
      if (onFileSelect) onFileSelect(file);
    }
  };

  // Función opcional para limpiar el archivo seleccionado
  const handleClear = () => {
    setSelectedFile(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
    if (onFileSelect) onFileSelect(null); // notificar que se limpió
  };

  return (
    <div
      style={{
        border: '2px dashed #ccc',
        borderRadius: '8px',
        padding: '40px',
        textAlign: 'center',
        backgroundColor: isDragging ? '#e6f4ff' : selectedFile ? '#f0fff4' : '#fafafa',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
        position: 'relative',
      }}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
    >
      {selectedFile ? (
        <div>
          <strong>Archivo seleccionado:</strong>
          <p style={{ margin: '8px 0', color: '#2e7d32' }}>{selectedFile.name}</p>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation(); // Evita que se abra el selector al hacer clic en "Eliminar"
              handleClear();
            }}
            style={{
              marginTop: '8px',
              padding: '4px 8px',
              fontSize: '14px',
              color: '#d32f2f',
              background: 'none',
              border: '1px solid #d32f2f',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Eliminar
          </button>
        </div>
      ) : (
        <p>
          {isDragging
            ? 'Suelta el archivo aquí...'
            : 'Arrastra un archivo aquí o haz clic para seleccionar'}
        </p>
      )}

      {/* Input oculto */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileInputChange}
      />
    </div>
  );
};

export default Dropzone;